import React from 'react';

import DynamicModal from '../../Common/DynamicModal';
import PINCheckHeader from './PINCheckHeader';
import PINCheckBody from './PINCheckBody';
import { PINCheckModalProps } from '../../../types/components';

const PINCheckModal = ({ open, setOpenPinCheckModal, handleSubmit, submitting }: PINCheckModalProps) => {
  return (
    <DynamicModal
      open={open}
      setClose={setOpenPinCheckModal}
      showCloseIcon={false}
      header={<PINCheckHeader />}
      body={<PINCheckBody handleSubmit={handleSubmit} setOpenPinCheckModal={setOpenPinCheckModal} submitting={submitting} />}
      className="v3"
    />
  );
}

export default PINCheckModal;